import i18next from '@packages/core/i18n';

import enLocales from './en';
import federatedAuthentication from './en/federated-authentication.json';
import itsmIntegrations from './en/itsm-integrations.json';
import telemetrySites from './en/telemetrySites.json';

i18next.addResourceBundle('en', 'account', enLocales);
i18next.addResourceBundle(
  'en',
  'federated-authentication',
  federatedAuthentication,
);
i18next.addResourceBundle('en', 'itsm-integrations', itsmIntegrations);
i18next.addResourceBundle('en', 'telemetrySites', telemetrySites);

export default i18next;
